export const BANNER_TEXT = {
  title: 'Cookie Preferences',
  description:
    'Manage your cookie settings. You can enable or disable different types of cookies below.',
  accept: 'Save preferences',
  link: 'Learn more',
};
